import type { ComponentNode } from '@canvas-builder/types/canvas'

export function applyOverridesToNode(component: ComponentNode, overrides: Record<string, any> = {}): ComponentNode {
  const nodeOverride = overrides[component.id]?.node_data

  const processedNode = {
    ...component,
    data: {
      ...component.data,
      ...nodeOverride,
    },
  }

  if (processedNode.children?.length) {
    processedNode.children = processedNode.children.map((child) => applyOverridesToNode(child, overrides))
  }

  return processedNode
}
